import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VBtn = _resolveComponent("VBtn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`iconn_button ${$props.fullWidth ? 'full_width' : ''}`)
  }, [
    _createVNode(_component_VBtn, {
      id: $props.id,
      style: {"letter-spacing":"0"},
      class: _normalizeClass(["button", $setup.buttonClass]),
      disabled: $props.disabled,
      ripple: false,
      loading: $props.loading,
      slim: $props.slim,
      "min-width": 0,
      onClick: $setup.onClick
    }, {
      default: _withCtx(() => [
        ($props.isConnectMeetBtn)
          ? (_openBlock(), _createBlock($setup["Tooltip"], {
              key: 0,
              text: "You need to be connected or registered to the same event to book a meeting",
              "max-width": 300
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Left icon "),
        ($props.leftIcon)
          ? (_openBlock(), _createBlock($setup["IconMaterial"], {
              key: 1,
              class: _normalizeClass(["left-icon", { 'margin-right_xs-df': $props.text }]),
              style: _normalizeStyle({ marginBottom: $setup.bottomMargin }),
              icon: $props.leftIcon,
              size: $setup.iconSize,
              variant: $props.iconVariant,
              color: 
          $setup.customColorIcon
            ? $setup.customColorIcon
            : $props.type === 'primary' && !$props.disabled
              ? 'white'
              : $props.disabled
                ? ''
                : $props.type === 'secondary_flat'
                  ? '#64748B'
                  : $props.type
        
            }, null, 8 /* PROPS */, ["class", "style", "icon", "size", "variant", "color"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Button text "),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("p", null, _toDisplayString($props.text), 1 /* TEXT */)
        ], true),
        _createCommentVNode(" Right icon "),
        ($props.rightIcon)
          ? (_openBlock(), _createBlock($setup["IconMaterial"], {
              key: 2,
              class: _normalizeClass(["right-icon", { 'margin-left_xs-df': $props.text }]),
              style: _normalizeStyle({ marginBottom: $setup.bottomMargin }),
              icon: $props.rightIcon,
              size: $setup.iconSize,
              color: 
          $setup.customColorIcon
            ? $setup.customColorIcon
            : $props.type === 'primary' && !$props.disabled
              ? 'white'
              : $props.disabled
                ? ''
                : $props.type === 'secondary_flat'
                  ? '#64748B'
                  : $props.type
        
            }, null, 8 /* PROPS */, ["class", "style", "icon", "size", "color"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["id", "class", "disabled", "loading", "slim"])
  ], 2 /* CLASS */))
}